export class DeleteFormTypes {
  static DELETE_MEMO_FORM = 'DELETE_MEMO_FORM';
}
